import { render } from "./CreditorList.vue?vue&type=template&id=63f2aa66"
import script from "./CreditorList.vue?vue&type=script&lang=js"
export * from "./CreditorList.vue?vue&type=script&lang=js"

import "./CreditorList.vue?vue&type=style&index=0&id=63f2aa66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__